import { useEffect } from 'react';

const Optimizely = () => {
  useEffect(() => {
    const currentPath = window?.location?.pathname;
    const shouldExcludeScript = currentPath === '/grow/optimzely-edge';
    
    if (shouldExcludeScript) {
      // Remove the script if it exists on the excluded path
      const existingScript = document.querySelector('script[src="https://cdn.optimizely.com/js/6209881250725888.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    }
  }, []);

  // Don't render the script tag for the excluded path
  if (typeof window !== 'undefined' && window.location?.pathname === '/grow/optimzely-edge') {
    return null;
  }

  return (
    <script src="https://cdn.optimizely.com/js/6209881250725888.js" />
  );
};

export default Optimizely; 
